module.exports = __webpack_public_path__ + "img/img-loan-back.fc7e8305.png";